import { ModuleRegisterContext, ModuleRegisterFn } from "@/module-register"

const registerHomeModule: ModuleRegisterFn = (_context: ModuleRegisterContext) => {
  console.log("home module registered!")
}

export default registerHomeModule
